import SoundTitleService from 'src/modules/soundTitle/SoundTitleService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'SOUNDTITLE_VIEW';

const soundTitleViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: soundTitleViewActions.FIND_STARTED,
      });

      const record = await SoundTitleService.find(id);

      dispatch({
        type: soundTitleViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundTitleViewActions.FIND_ERROR,
      });

      getHistory().push('/sound-title');
    }
  },
};

export default soundTitleViewActions;
